import PropTypes from 'prop-types'
import React from 'react'

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="content">
      <div className="inner">
                <h1>Éamonn Ó Cearnaigh</h1>
                <h3>Data Science MSci Student | Software Engineer | Aspiring Researcher</h3>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('CV')
            }}
          >
            Cv
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('Projects')
            }}
          >
            Projects
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('Bio')
            }}
          >
            Bio
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('Contact')
            }}
          >
            Contact
          </button>
        </li>
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
